import { useState, useEffect } from 'react';
import { throttle } from 'lodash';
import { isBrowser } from './is-browser';
import { sizes } from '../components/theme/breakpoint';

export default function useWindowSize() {
  // determine if we are currently on SSR or browser and use sensible defaults
  const [windowSize, setWindowSize] = useState({
    width: !isBrowser ? 1200 : window.innerWidth,
    height: !isBrowser ? 800 : window.innerHeight,
    isDesktop: !isBrowser ? true : window.innerWidth >= sizes.desktop,
    isMobile: !isBrowser ? false : window.innerWidth < sizes.tablet,
    // isClient is true when we are in browser rather than server
    // used either as a guard or in a react key (to trigger DOM tree refresh on hydrate)
    isClient: false,
  });

  function changeWindowSize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
      isDesktop: window.innerWidth >= sizes.desktop,
      isMobile: window.innerWidth < sizes.tablet,
      isClient: true,
    });
  }

  useEffect(() => {
    // run once for initial client values
    changeWindowSize();

    // throttle window size function to reduce overhead
    const throttledWindowSize = throttle(changeWindowSize, 100);

    window.addEventListener('resize', throttledWindowSize);

    // remove the event listener on component unmount
    return () => {
      window.removeEventListener('resize', throttledWindowSize);
    };
    // empty dependency array ensures we initialise once only, on component mount
  }, []);

  return windowSize;
}

export const useDeviceType = () => {
  const { isMobile, isDesktop } = useWindowSize();
  // eslint-disable-next-line no-nested-ternary
  return isMobile ? 'mobile' : isDesktop ? 'desktop' : 'tablet';
};
